<template>
    <div class="ui-not-found-data">
        <div class="ui-not-found-data__image">
            <img v-svg-inline src="@/assets/icons/ui/not-found-data.svg" />
        </div>

        <div class="ui-not-found-data__title">По вашему запросу ничего не найдено</div>

        <div class="ui-not-found-data__subtitle">Попробуйте изменить параметры фильтра</div>
    </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
    @use './UINotFoundData.scss' as *;
</style>
